import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  TextField,
  Skeleton,
} from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import { SCREEN_IDS } from "../FullComponent.js";
import {
  insertRecMerma,
  getMovimientosRecMerma,
} from "../../services/ConnectDataBase.js";
import { BACKGROUND_COLORS, BORDER_COLORS, TEXT_COLORS, STATUS_COLORS, MUI_COLORS } from "../../style/colors.js";
import { useSelector, useDispatch } from "react-redux";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { AddCircle } from "@mui/icons-material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { translateText } from "../../translations/translationService";
import { Dialog } from "@mui/material";
import * as XLSX from "xlsx";
import { notify } from "../../services/ui/notify";

// Configuración de skeletons de carga
const SKELETON_CONFIG = {
  rows: 8,              // Número de filas de skeletons
  height: 20,           // Altura de los skeletons en px
  widthLabel: "100%",    // Ancho del skeleton de etiqueta
  widthValue: "100%",    // Ancho del skeleton de valor
};

export default function ComponentRecuperacionMerma() {
  const [rows, setRows] = useState([]);
  const [mermasDb, setMermasDb] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);
  const [openModifyDialog, setOpenModifyDialog] = useState(false);
  const [cuentaMetales, setCuentaMetales] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const lang = useSelector((state) => state.lang.value);
  const [formData, setFormData] = useState({
    equipo: "",
    fechaRecogida: "",
    pesoBruto: "",
  });
  const name = useSelector((state) => state.user.name);
  const team = useSelector((state) => state.user.team);
  const [selectedRecuperaciones, setSelectedRecuperaciones] = useState([]);
  const [newRow, setNewRow] = useState({
    recuperacion: "",
    equipo: "",
    fechaRecogida: "",
    pesoBruto: "",
    pesoLingote: "",
    ley: "",
    fechaEnvio: "",
    auGr: "",
    agGr: "",
    ptGr: "",
    pdGr: "",
    fechaCtaPesos: "",
    imagen: null,
    imagenURL: null,
  });
  const opcionesRecuperacion = [
    { label: translateText("Fundición", lang), value: "1" },
    { label: translateText("Mecanizado", lang), value: "2" },
    { label: translateText("Repaso", lang), value: "3" },
    { label: translateText("Engastado", lang), value: "4" },
    { label: translateText("Pulido", lang), value: "5" },
    { label: translateText("Baños", lang), value: "6" },
  ];
  const recuperacionMap = {
    1: "Fundición",
    2: "Mecanizado",
    3: "Repaso",
    4: "Engastado",
    5: "Pulido",
    6: "Baños",
  };

  const [recibimosValues, setRecibimosValues] = useState({
    Au: "",
    Ag: "",
    Pt: "",
    Pd: "",
  });

  useEffect(() => {
    if (selectedRow) {
      setRecibimosValues({
        Au: selectedRow.Gramos_au,
        Ag: selectedRow.Gramos_ag,
        Pt: selectedRow.Gramos_pt,
        Pd: selectedRow.Gramos_pd,
      });
    }
  }, [selectedRow]);

  useEffect(() => {
    getDatos();
  }, []);

  const handleInputChange = (key, value) => {
    setNewRow((prev) => ({ ...prev, [key]: value }));
  };

  function getPercentage(value, total) {
    const val = parseFloat(value) || 0;
    const t = parseFloat(total) || 0;
    if (t === 0) return "0.00";
    return ((val / t) * 100).toFixed(2);
  }

  const formatDateToISO = (date) => {
    if (!date || isNaN(new Date(date).getTime())) {
      return ""; // Retorna vacío si la fecha no es válida
    }
    return new Date(date).toISOString().slice(0, 19).replace("T", " ");
  };

  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    setSelectedRecuperaciones((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const getDatos = async () => {
    try {
      setIsLoading(true);
      const fullData = await getMovimientosRecMerma(
        SCREEN_IDS.GENERAL,
        "getMovimientosRecMerma"
      );

      if (Array.isArray(fullData)) {
        setMermasDb(fullData);
      } else {
        console.error("No se recibió un array del servidor:", fullData);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenModifyDialog = (row) => {
    setSelectedRow(row);
    setOpenModifyDialog(true);
  };

  const handleCloseModifyDialog = async () => {
    if (!selectedRow) return;

    const pLingoteRecibimos = ["Au", "Ag", "Pt", "Pd"].reduce((acc, metal) => {
      const val = parseFloat(recibimosValues[metal]) || 0;
      return acc + val;
    }, 0);

    // Crear un nuevo objeto con solo los datos que se deben modificar
    const modifiedRow = {
      modificacion: true,
      usuario: name,
      id_original: selectedRow.id,
      Gramos_au: recibimosValues.Au,
      Gramos_ag: recibimosValues.Ag,
      Gramos_pt: recibimosValues.Pt,
      Gramos_pd: recibimosValues.Pd,
      cuenta_metales: cuentaMetales ? 1 : 0,
      peso_lingote_recibimos: pLingoteRecibimos,
    };

    try {
      await insertRecMerma(
        SCREEN_IDS.GENERAL,
        "insertRecMerma",
        name,
        [modifiedRow] // Solo enviamos los datos relevantes
      );

      getDatos(); // Refrescar la tabla después de modificar
    } catch (error) {
      console.error("Error al enviar los datos modificados:", error);
      notify.error("Ocurrió un error al enviar la modificación.");
    }

    setOpenModifyDialog(false);
    setSelectedRow(null);
  };

  function formatNumber(numStr) {
    if (!numStr) return "0,00";
    const value = parseFloat(numStr);
    return value.toLocaleString("es-ES", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  function parseNumber(value) {
    const val = parseFloat(value);
    return isNaN(val) ? null : val;
  }

  function parseDateSqlsrv(fechaObj) {
    if (!fechaObj || !fechaObj.date) return null;
    return new Date(fechaObj.date);
  }

  const handleExportExcel = () => {
    try {
      if (mermasDb.length === 0) {
        console.warn("No hay datos para exportar.");
        notify.info("No hay datos para exportar.");
        return;
      }

      const formattedData = mermasDb.map((row) => ({
        usuario: row.usuario || "",
        lugar_recogida: row.lugar_recogida || "",
        equipo: row.equipo || "",
        fecha_recogida: parseDateSqlsrv(row.fecha_recogida),
        peso_bruto: parseNumber(row.peso_bruto),
        peso_lingote: parseNumber(row.peso_lingote),
        ley: parseNumber(row.ley),
        fecha_afinaje: parseDateSqlsrv(row.fecha_afinaje),
        Gramos_au: parseNumber(row.Gramos_au),
        Gramos_ag: parseNumber(row.Gramos_ag),
        Gramos_pt: parseNumber(row.Gramos_pt),
        Gramos_pd: parseNumber(row.Gramos_pd),
        fecha_cta_pesos: parseDateSqlsrv(row.fecha_cta_pesos),
      }));

      if (formattedData.length === 0) {
        console.warn("No hay datos formateados para exportar.");
        notify.info("No hay datos formateados para exportar.");
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(formattedData, {
        cellDates: true,
        dateNF: "dd/mm/yyyy",
      });

      if (!worksheet["!ref"]) {
        console.warn("La hoja de cálculo está vacía.");
        notify.info("La hoja de cálculo está vacía.");
        return;
      }

      worksheet["!autofilter"] = { ref: worksheet["!ref"] };

      const columnWidths = Object.keys(formattedData[0] || {}).map((key) => {
        if (key.includes("fecha")) {
          return { wch: 12 };
        }
        const maxLength = Math.max(
          key.length,
          ...formattedData.map((row) =>
            row[key] ? row[key].toString().length : 0
          )
        );
        return { wch: maxLength + 2 };
      });
      worksheet["!cols"] = columnWidths;

      const headerStyle = {
        font: { bold: true, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "4A90E2" } },
        alignment: { horizontal: "center", vertical: "center" },
      };
      Object.keys(formattedData[0] || {}).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: colIndex });
        if (worksheet[cellRef]) {
          worksheet[cellRef].s = headerStyle;
        }
      });

      worksheet["!rows"] = [{ hpx: 15 }];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Movimientos Merma");

      XLSX.writeFile(workbook, "reporte_mermas.xlsx");
    } catch (error) {
      console.error("Error exportando Excel:", error);
      notify.error("Error exportando Excel. Ver la consola para más detalles.");
    }
  };

  function formatSqlsrvDate(sqlDateObj) {
    if (!sqlDateObj || !sqlDateObj.date) return "";
    return new Date(sqlDateObj.date).toISOString().slice(0, 10);
  }

  const handleAddRecuperacion = async () => {
    if (selectedRecuperaciones.length === 0) {
      notify.warn("Selecciona al menos una opción de recuperación.");
      return;
    }
    if (!formData.fechaRecogida || !formData.pesoBruto) {
      notify.warn("Todos los campos son obligatorios.");
      return;
    }

    // Concatenamos los valores seleccionados de los checkboxes en una cadena
    const recuperacionString = selectedRecuperaciones.join("");

    const dataParaEnviar = [
      {
        recuperacion: recuperacionString,
        equipo: team,
        fechaRecogida: formData.fechaRecogida,
        pesoBruto: formData.pesoBruto,
      },
    ];

    try {
      await insertRecMerma(
        SCREEN_IDS.GENERAL,
        "insertRecMerma",
        name,
        dataParaEnviar
      );
      notify.success("Recuperación añadida con éxito.");
      getDatos(); // Recargar datos
      setSelectedRecuperaciones([]); // Reset checkboxes
      setFormData({ equipo: "", fechaRecogida: "", pesoBruto: "" }); // Reset formulario
    } catch (error) {
      console.error("Error al enviar los datos:", error);
      notify.error("Ocurrió un error al enviar la recuperación.");
    }
  };

  const validarCampos = (row) => {
    if (!newRow.pesoLingote && newRow.pesoLingote !== 0) {
      notify.warn("El campo 'P.Lingote' es obligatorio.");
      return false;
    }

    if (!newRow.ley && newRow.ley !== 0) {
      notify.warn("El campo 'Ley (%)' es obligatorio.");
      return false;
    }

    if (!newRow.fechaEnvio || !newRow.fechaEnvio.trim()) {
      notify.warn("El campo 'Fecha afinaje' es obligatorio.");
      return false;
    }

    if (!newRow.auGr && newRow.auGr !== 0) {
      notify.warn("El campo 'Au g.' es obligatorio.");
      return false;
    }

    if (!newRow.agGr && newRow.agGr !== 0) {
      notify.warn("El campo 'Ag g.' es obligatorio.");
      return false;
    }

    if (!newRow.ptGr && newRow.ptGr !== 0) {
      notify.warn("El campo 'Pt g.' es obligatorio.");
      return false;
    }

    if (!newRow.pdGr && newRow.pdGr !== 0) {
      notify.warn("El campo 'Pd g.' es obligatorio.");
      return false;
    }

    if (!newRow.fechaCtaPesos || !newRow.fechaCtaPesos.trim()) {
      notify.warn("El campo 'Fecha cta. Pesos' es obligatorio.");
      return false;
    }

    const pesoBrutoVal = parseFloat(row.peso_bruto) || 0;
    const pesoLingoteVal = parseFloat(newRow.pesoLingote) || 0;

    if (pesoLingoteVal > pesoBrutoVal) {
      notify.warn("El peso del lingote no puede ser superior al peso bruto.");
      return false;
    }

    if (!newRow.imagen) {
      notify.warn("Debes agregar una imagen.");
      return false;
    }

    const sumMetales =
      (parseFloat(newRow.auGr) || 0) +
      (parseFloat(newRow.agGr) || 0) +
      (parseFloat(newRow.ptGr) || 0) +
      (parseFloat(newRow.pdGr) || 0);

    if (sumMetales > pesoLingoteVal) {
      notify.warn(
        `El peso del lingote es: ${pesoLingoteVal} y la suma de los metales es: ${sumMetales}.
La suma de Au, Ag, Pt y Pd no puede exceder el peso del lingote.`
      );

      return false;
    }

    return true;
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.size <= 500 * 1024) {
      const imageURL = URL.createObjectURL(file);
      setNewRow({ ...newRow, imagen: file, imagenURL: imageURL });
    } else {
      notify.error("Error: La imagen debe ser menor a 500KB.");
    }
  };

  const handleRowFileUpload = (event, index) => {
    const file = event.target.files[0];
    if (file && file.size <= 500 * 1024) {
      const imageURL = URL.createObjectURL(file);
      const updatedRows = [...rows];
      updatedRows[index] = {
        ...updatedRows[index],
        imagen: file,
        imagenURL: imageURL,
      };
      setRows(updatedRows);
    } else {
      notify.error("Error: La imagen debe ser menor a 500KB.");
    }
  };

  const handleAddRow = async (row) => {
    // 1. Validar campos antes de actualizar
    const esValido = validarCampos(row);
    if (!esValido) {
      notify.warn("Por favor, rellena todos los campos obligatorios.");
      return;
    }

    const fechaAfinajeFormat = newRow.fechaEnvio
      ? formatDateToISO(newRow.fechaEnvio)
      : "";
    const fechaCtaPesosFormat = newRow.fechaCtaPesos
      ? formatDateToISO(newRow.fechaCtaPesos)
      : "";

    const updatedRow = {
      id_original: row.id,
      recuperacion: row.recuperacion,
      equipo: team,
      fechaRecogida: row.fechaRecogida,
      pesoBruto: row.pesoBruto,
      pesoLingote: newRow.pesoLingote,
      ley: newRow.ley,
      Gramos_au: newRow.auGr,
      Gramos_ag: newRow.agGr,
      Gramos_pt: newRow.ptGr,
      Gramos_pd: newRow.pdGr,
      fecha_afinaje: fechaAfinajeFormat,
      fecha_cta_pesos: fechaCtaPesosFormat,
      imagen: newRow.imagen,
      update: true,
    };

    console.log("Fecha Afinaje antes de enviar:", newRow.fechaEnvio);
    console.log("Fecha Cta Pesos antes de enviar:", newRow.fechaCtaPesos);
    console.log(
      "Fecha Afinaje formateada:",
      formatDateToISO(newRow.fechaEnvio)
    );
    console.log(
      "Fecha Cta Pesos formateada:",
      formatDateToISO(newRow.fechaCtaPesos)
    );

    try {
      await insertRecMerma(SCREEN_IDS.GENERAL, "insertRecMerma", name, [
        updatedRow,
      ]);

      setNewRow({
        recuperacion: "",
        equipo: "",
        fechaRecogida: "",
        pesoBruto: "",
        pesoLingote: "",
        ley: "",
        fechaEnvio: "",
        auGr: "",
        agGr: "",
        ptGr: "",
        pdGr: "",
        fechaCtaPesos: "",
        imagen: null,
        imagenURL: null,
      });

      getDatos(); // 5. Recargar la tabla con la información actualizada
    } catch (error) {
      console.error("Error al actualizar los datos:", error);
      notify.error("Ocurrió un error al actualizar la línea.");
    }
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpenModal(true);
  };
  const handleCloseDialogWithoutSaving = () => {
    setOpenModifyDialog(false); // Solo cierra el modal sin guardar
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedImage(null);
  };

  const handleRemoveNewImage = () => {
    setNewRow({ ...newRow, imagen: null, imagenURL: null });
  };

  return (
    <Box sx={{ padding: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: -3 }}>
        <IconButton onClick={handleOpenDialog} sx={{ color: MUI_COLORS.primary }}>
          <AddCircle fontSize='medium' />
        </IconButton>
        <IconButton
          onClick={handleExportExcel}
          style={{
            color: MUI_COLORS.primary,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}>
          <InsertDriveFileIcon fontSize='medium' />
        </IconButton>
      </Box>
      <TableContainer component={Paper} sx={{ maxHeight: "70vh" }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {[
                "id",
                "Donde",
                "Equipo",
                "Fecha recogida",
                "P.Bruto",
                "P.Lingote (g)",
                "Ley (%)",
                "Fecha afinaje",
                "Au g.",
                "Ag g.",
                "Pt g.",
                "Pd g.",
                "Fecha cta. Pesos",
                "Imagen",
                "Enviar",
              ].map((title) => (
                <TableCell
                  key={title}
                  sx={{
                    backgroundColor: BORDER_COLORS.lightGray,
                    fontWeight: "bold",
                    textAlign: "center",
                    padding: "3px",
                    border: `1px solid ${BORDER_COLORS.LIGHT_GRAY}`,
                    width: "5%",
                  }}>
                  {translateText(title, lang)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <>
                {[...Array(SKELETON_CONFIG.rows)].map((_, rowIndex) => (
                  <TableRow key={rowIndex} sx={{ height: "10px" }}>
                    {[...Array(15)].map((_, colIndex) => (
                      <TableCell
                        key={colIndex}
                        align='center'
                        sx={{ padding: "0px" }}>
                        <Skeleton variant="text" width={SKELETON_CONFIG.widthValue} height={SKELETON_CONFIG.height} />
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </>
            ) : (
              <>
                {rows.map((row, index) => (
              <TableRow key={index} sx={{ height: "10px" }}>
                <TableCell align='center' sx={{ padding: "0px" }}>
                  {row.recuperacion}
                </TableCell>
                <TableCell align='center' sx={{ padding: "0px" }}>
                  {row.equipo}
                </TableCell>
                <TableCell align='center' sx={{ padding: "0px" }}>
                  {row.fechaRecogida}
                </TableCell>
                <TableCell align='center' sx={{ padding: "0px" }}>
                  {row.pesoBruto}
                </TableCell>
                <TableCell align='center' sx={{ padding: "0px" }}>
                  {row.pesoLingote}
                </TableCell>
                <TableCell align='center' sx={{ padding: "0px" }}>
                  {row.ley}
                </TableCell>
                <TableCell align='center' sx={{ padding: "0px" }}>
                  {row.fechaEnvio}
                </TableCell>
                <TableCell align='center' sx={{ padding: "0px" }}>
                  {row.auGr}
                </TableCell>
                <TableCell align='center' sx={{ padding: "0px" }}>
                  {row.agGr}
                </TableCell>
                <TableCell align='center' sx={{ padding: "0px" }}>
                  {row.ptGr}
                </TableCell>
                <TableCell align='center' sx={{ padding: "0px" }}>
                  {row.pdGr}
                </TableCell>
                <TableCell align='center' sx={{ padding: "0px" }}>
                  {row.fechaCtaPesos}
                </TableCell>
                <TableCell align='center' sx={{ padding: "0px" }}>
                  {row.imagenURL ? (
                    <img
                      src={row.imagenURL}
                      alt='Preview'
                      style={{
                        width: "50px",
                        height: "50px",
                        objectFit: "cover",
                        borderRadius: "4px",
                      }}
                    />
                  ) : (
                    <IconButton component='label'>
                      <PhotoCamera />
                      <input
                        type='file'
                        hidden
                        accept='image/*'
                        onChange={(e) => handleRowFileUpload(e, index)}
                      />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}

            {mermasDb.map((row, index) => (
              <React.Fragment key={row.id}>
                {/* FILA PRINCIPAL */}
                <TableRow>
                  <TableCell align='center' sx={{ padding: "0px" }}>
                    {row.id}
                  </TableCell>
                  <TableCell align='center' sx={{ padding: "0px" }}>
                    {row.lugar_recogida
                      .split("")
                      .map((num) => recuperacionMap[num] || num)
                      .join(", ")}
                  </TableCell>
                  <TableCell align='center' sx={{ padding: "0px" }}>
                    {row.equipo}
                  </TableCell>
                  <TableCell align='center' sx={{ padding: "0px" }}>
                    {formatSqlsrvDate(row.fecha_recogida)}
                  </TableCell>
                  <TableCell align='center' sx={{ padding: "0px" }}>
                    {formatNumber(row.peso_bruto)}
                  </TableCell>
                  <TableCell align='center' sx={{ padding: "0px" }}>
                    {row.peso_lingote && parseFloat(row.peso_lingote) !== 0 ? (
                      formatNumber(row.peso_lingote) // Si tiene un valor, se muestra sin input
                    ) : (
                      <input
                        type='number'
                        value={newRow.pesoLingote}
                        onChange={(e) =>
                          handleInputChange("pesoLingote", e.target.value)
                        }
                        style={{
                          fontSize: "14px",
                          textAlign: "center",
                          width: "100%",
                          height: "20px",
                          border: "none",
                          borderBottom: `1px solid ${BORDER_COLORS.LIGHT_GRAY}`,
                          outline: "none",
                        }}
                      />
                    )}
                  </TableCell>

                  <TableCell align='center' sx={{ padding: "0px" }}>
                    {row.ley && parseFloat(row.ley) !== 0 ? (
                      formatNumber(row.ley) // Si tiene un valor, se muestra formateado
                    ) : (
                      <input
                        type='number'
                        value={newRow.ley}
                        onChange={(e) =>
                          handleInputChange("ley", e.target.value)
                        }
                        style={{
                          fontSize: "14px",
                          textAlign: "center",
                          width: "100%",
                          height: "20px",
                          border: "none",
                          borderBottom: `1px solid ${BORDER_COLORS.LIGHT_GRAY}`,
                          outline: "none",
                        }}
                      />
                    )}
                  </TableCell>

                  <TableCell align='center' sx={{ padding: "0px" }}>
                    {row.fecha_afinaje &&
                    row.fecha_afinaje.date !== "1900-01-01 00:00:00.000000" ? (
                      formatSqlsrvDate(row.fecha_afinaje)
                    ) : (
                      <input
                        type='date'
                        value={newRow.fechaEnvio}
                        onChange={(e) =>
                          handleInputChange("fechaEnvio", e.target.value)
                        }
                        style={{
                          fontSize: "14px",
                          textAlign: "center",
                          width: "100%",
                          height: "20px",
                          border: "none",
                          borderBottom: `1px solid ${BORDER_COLORS.LIGHT_GRAY}`,
                          outline: "none",
                        }}
                      />
                    )}
                  </TableCell>

                  <TableCell align='center' sx={{ padding: "0px" }}>
                    {row.Gramos_au && row.Gramos_au !== ".0000" ? (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}>
                        <Box sx={{ fontSize: "14px" }}>
                          {`${formatNumber(row.Gramos_au)} g.`}
                        </Box>
                        <Box sx={{ fontSize: "12px", color: TEXT_COLORS.SECONDARY }}>
                          {`${getPercentage(row.Gramos_au, row.peso_lingote)}%`}
                        </Box>
                      </Box>
                    ) : (
                      <input
                        type='number'
                        value={newRow.auGr}
                        onChange={(e) =>
                          handleInputChange("auGr", e.target.value)
                        }
                        style={{
                          fontSize: "14px",
                          textAlign: "center",
                          width: "100%",
                          height: "20px",
                          border: "none",
                          borderBottom: `1px solid ${BORDER_COLORS.LIGHT_GRAY}`,
                          outline: "none",
                        }}
                      />
                    )}
                  </TableCell>

                  <TableCell align='center' sx={{ padding: "0px" }}>
                    {row.Gramos_ag && row.Gramos_ag !== ".0000" ? (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}>
                        <Box sx={{ fontSize: "14px" }}>
                          {`${formatNumber(row.Gramos_ag)} g.`}
                        </Box>
                        <Box sx={{ fontSize: "12px", color: TEXT_COLORS.SECONDARY }}>
                          {`${getPercentage(row.Gramos_ag, row.peso_lingote)}%`}
                        </Box>
                      </Box>
                    ) : (
                      <input
                        type='number'
                        value={newRow.agGr}
                        onChange={(e) =>
                          handleInputChange("agGr", e.target.value)
                        }
                        style={{
                          fontSize: "14px",
                          textAlign: "center",
                          width: "100%",
                          height: "20px",
                          border: "none",
                          borderBottom: `1px solid ${BORDER_COLORS.LIGHT_GRAY}`,
                          outline: "none",
                        }}
                      />
                    )}
                  </TableCell>
                  <TableCell align='center' sx={{ padding: "0px" }}>
                    {row.Gramos_pt && row.Gramos_pt !== ".0000" ? (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}>
                        <Box sx={{ fontSize: "14px" }}>
                          {`${formatNumber(row.Gramos_pt)} g.`}
                        </Box>
                        <Box sx={{ fontSize: "12px", color: TEXT_COLORS.SECONDARY }}>
                          {`${getPercentage(row.Gramos_pt, row.peso_lingote)}%`}
                        </Box>
                      </Box>
                    ) : (
                      <input
                        type='number'
                        value={newRow.ptGr}
                        onChange={(e) =>
                          handleInputChange("ptGr", e.target.value)
                        }
                        style={{
                          fontSize: "14px",
                          textAlign: "center",
                          width: "100%",
                          height: "20px",
                          border: "none",
                          borderBottom: `1px solid ${BORDER_COLORS.LIGHT_GRAY}`,
                          outline: "none",
                        }}
                      />
                    )}
                  </TableCell>

                  <TableCell align='center' sx={{ padding: "0px" }}>
                    {row.Gramos_pd && row.Gramos_pd !== ".0000" ? (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}>
                        <Box sx={{ fontSize: "14px" }}>
                          {`${formatNumber(row.Gramos_pd)} g.`}
                        </Box>
                        <Box sx={{ fontSize: "12px", color: TEXT_COLORS.SECONDARY }}>
                          {`${getPercentage(row.Gramos_pd, row.peso_lingote)}%`}
                        </Box>
                      </Box>
                    ) : (
                      <input
                        type='number'
                        value={newRow.pdGr}
                        onChange={(e) =>
                          handleInputChange("pdGr", e.target.value)
                        }
                        style={{
                          fontSize: "14px",
                          textAlign: "center",
                          width: "100%",
                          height: "20px",
                          border: "none",
                          borderBottom: `1px solid ${BORDER_COLORS.LIGHT_GRAY}`,
                          outline: "none",
                        }}
                      />
                    )}
                  </TableCell>

                  <TableCell align='center' sx={{ padding: "0px" }}>
                    {row.fecha_cta_pesos &&
                    row.fecha_cta_pesos.date !==
                      "1900-01-01 00:00:00.000000" ? (
                      formatSqlsrvDate(row.fecha_cta_pesos)
                    ) : (
                      <input
                        type='date'
                        value={newRow.fechaCtaPesos}
                        onChange={(e) =>
                          handleInputChange("fechaCtaPesos", e.target.value)
                        }
                        style={{
                          fontSize: "14px",
                          textAlign: "center",
                          width: "100%",
                          height: "20px",
                          border: "none",
                          borderBottom: `1px solid ${BORDER_COLORS.LIGHT_GRAY}`,
                          outline: "none",
                        }}
                      />
                    )}
                  </TableCell>

                  <TableCell align='center' sx={{ padding: "2px" }}>
                    {row.imagen ? (
                      <img
                        src={row.imagen}
                        alt='Preview'
                        style={{
                          width: "50px",
                          height: "50px",
                          objectFit: "cover",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleImageClick(row.imagen)}
                      />
                    ) : newRow.imagenURL ? (
                      <Box
                        sx={{ position: "relative", display: "inline-block" }}>
                        <img
                          src={newRow.imagenURL}
                          alt='Preview'
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "cover",
                            borderRadius: "4px",
                          }}
                        />
                        <IconButton
                          onClick={handleRemoveNewImage}
                          sx={{
                            position: "absolute",
                            top: "-8px",
                            right: "-8px",
                            backgroundColor: "#fff",
                            border: `1px solid ${BORDER_COLORS.LIGHT_GRAY}`,
                            borderRadius: "50%",
                            padding: "2px",
                            fontSize: "10px",
                            "&:hover": { backgroundColor: STATUS_COLORS.ERROR_LIGHT },
                          }}>
                          ✖
                        </IconButton>
                      </Box>
                    ) : (
                      <IconButton component='label'>
                        <PhotoCamera />
                        <input
                          type='file'
                          hidden
                          accept='image/*'
                          onChange={handleFileUpload}
                        />
                      </IconButton>
                    )}
                  </TableCell>

                  <TableCell align='center' sx={{ padding: "0px" }}>
                    {row.peso_lingote &&
                    row.ley &&
                    row.fecha_afinaje?.date !== "1900-01-01 00:00:00.000000" &&
                    row.Gramos_au &&
                    row.Gramos_ag &&
                    row.Gramos_pt &&
                    row.Gramos_pd &&
                    row.fecha_cta_pesos?.date !==
                      "1900-01-01 00:00:00.000000" ? (
                      row.modificaciones && row.modificaciones.length > 0 ? (
                        // Si tiene sublíneas, mostrar "-"
                        <Box sx={{ fontSize: "20px", color: STATUS_COLORS.success }}>
                          ✔️
                        </Box>
                      ) : (
                        // Si no tiene sublíneas, mostrar "Modificar"
                        <Button
                          variant='contained'
                          onClick={() => handleOpenModifyDialog(row)}
                          sx={{
                            fontSize: "14px",
                            padding: "4px 10px",
                            backgroundColor: MUI_COLORS.warning,
                            "&:hover": { backgroundColor: MUI_COLORS.warningDark },
                          }}>
                          Modificar
                        </Button>
                      )
                    ) : (
                      // Si falta algún dato, mostrar "Añadir"
                      <Button
                        variant='contained'
                        onClick={() => handleAddRow(row)}
                        sx={{
                          fontSize: "14px",
                          backgroundColor: MUI_COLORS.primary,
                          "&:hover": { backgroundColor: MUI_COLORS.primaryLight },
                        }}>
                        Añadir
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
                {row.modificaciones &&
                  row.modificaciones.length > 0 &&
                  row.modificaciones.map((mod, modIndex) => (
                    <TableRow
                      key={`${row.id}-mod-${modIndex}`}
                      sx={{
                        backgroundColor: STATUS_COLORS.successLight,
                      }}>
                      {/* Color verde */}
                      <TableCell
                        align='center'
                        colSpan={0}
                        sx={{
                          padding: "0px",
                          borderBottom: "2px solid #d0d0d0",
                        }}>
                        {formatSqlsrvDate(mod.fecha_movimiento)}
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{
                          padding: "0px",
                          borderBottom: "2px solid #d0d0d0",
                        }}>
                        {mod.usuario}
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{
                          padding: "0px",
                          borderBottom: "2px solid #d0d0d0",
                        }}>
                        {""}
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{
                          padding: "0px",
                          borderBottom: "2px solid #d0d0d0",
                        }}>
                        {""}
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{
                          padding: "0px",
                          borderBottom: "2px solid #d0d0d0",
                        }}>
                        {""}
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{
                          padding: "0px",
                          borderBottom: "2px solid #d0d0d0",
                        }}>
                        {formatNumber(mod.peso_lingote)}
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{
                          padding: "0px",
                          borderBottom: "2px solid #d0d0d0",
                        }}>
                        {""}
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{
                          padding: "0px",
                          borderBottom: "2px solid #d0d0d0",
                        }}>
                        {""}
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{
                          padding: "0px",
                          borderBottom: "2px solid #d0d0d0",
                        }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}>
                          <Box sx={{ fontSize: "14px" }}>
                            {`${formatNumber(mod.Gramos_au)} g.`}
                          </Box>
                          <Box sx={{ fontSize: "12px", color: TEXT_COLORS.SECONDARY }}>
                            {`${getPercentage(
                              mod.Gramos_au,
                              row.peso_lingote
                            )}%`}
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{
                          padding: "0px",
                          borderBottom: "2px solid #d0d0d0",
                        }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}>
                          <Box sx={{ fontSize: "14px" }}>
                            {`${formatNumber(mod.Gramos_ag)} g.`}
                          </Box>
                          <Box sx={{ fontSize: "12px", color: TEXT_COLORS.SECONDARY }}>
                            {`${getPercentage(
                              mod.Gramos_ag,
                              row.peso_lingote
                            )}%`}
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{
                          padding: "0px",
                          borderBottom: "2px solid #d0d0d0",
                        }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}>
                          <Box sx={{ fontSize: "14px" }}>
                            {`${formatNumber(mod.Gramos_pt)} g.`}
                          </Box>
                          <Box sx={{ fontSize: "12px", color: TEXT_COLORS.SECONDARY }}>
                            {`${getPercentage(
                              mod.Gramos_pt,
                              row.peso_lingote
                            )}%`}
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{
                          padding: "0px",
                          borderBottom: "2px solid #d0d0d0",
                        }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}>
                          <Box sx={{ fontSize: "14px" }}>
                            {`${formatNumber(mod.Gramos_pd)} g.`}
                          </Box>
                          <Box sx={{ fontSize: "12px", color: TEXT_COLORS.SECONDARY }}>
                            {`${getPercentage(
                              mod.Gramos_pd,
                              row.peso_lingote
                            )}%`}
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell
                        align='center'
                        colSpan={3}
                        sx={{
                          padding: "0px",
                          borderBottom: "2px solid #d0d0d0",
                        }}>
                        {mod.cuenta_metales === 1
                          ? "Añadido a cuenta metales"
                          : "Devuelto"}
                      </TableCell>
                    </TableRow>
                  ))}
              </React.Fragment>
            ))}
              </>
            )}
          </TableBody>
        </Table>
        <Dialog
          open={openModal}
          onClose={handleCloseModal}
          maxWidth='lg' // Ajusta si quieres limitar el tamaño
          fullWidth={true} // Ajusta a tu gusto
        >
          <Box sx={{ position: "relative", p: 2 }}>
            {selectedImage && (
              <img
                src={selectedImage}
                alt='Vista ampliada'
                style={{
                  maxWidth: "90vw",
                  maxHeight: "90vh",
                  objectFit: "contain",
                }}
              />
            )}
          </Box>
        </Dialog>
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth='sm'
          fullWidth>
          <DialogTitle>
            {translateText("Agregar Nueva Recuperación", lang)}
          </DialogTitle>
          <DialogContent>
            <Box
              sx={{ display: "flex", flexDirection: "column", gap: 3, p: 2 }}>
              {/* Checkboxes en dos columnas */}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 1,
                }}>
                {opcionesRecuperacion.map((option) => (
                  <FormControlLabel
                    key={option.value}
                    control={
                      <Checkbox
                        value={option.value}
                        checked={selectedRecuperaciones.includes(option.value)}
                        onChange={handleCheckboxChange}
                      />
                    }
                    label={option.label}
                  />
                ))}
              </Box>

              {/* Inputs */}
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <TextField
                  name='fechaRecogida'
                  label={translateText("Fecha Recogida", lang)}
                  type='date'
                  value={formData.fechaRecogida || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, fechaRecogida: e.target.value })
                  }
                  fullWidth
                  InputLabelProps={{ shrink: true }} // Asegura que el label no se sobreponga
                />

                <TextField
                  name='pesoBruto'
                  label={translateText("Peso Bruto", lang)}
                  type='number'
                  value={formData.pesoBruto || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormData({
                      ...formData,
                      pesoBruto: value === "" ? "" : parseFloat(value),
                    });
                  }}
                  fullWidth
                  InputLabelProps={{ shrink: true }} // Evita que el label se superponga
                />
              </Box>

              {/* Botón para enviar */}
              <Button
                variant='contained'
                color='primary'
                onClick={handleAddRecuperacion}
                sx={{ alignSelf: "center", mt: 2 }}>
                {translateText("Añadir", lang)}
              </Button>
            </Box>
          </DialogContent>
        </Dialog>

        <Dialog
          open={openModifyDialog}
          onClose={handleCloseDialogWithoutSaving}
          maxWidth='sm'
          fullWidth
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "16px",
              padding: "30px",
              background: "rgba(255, 255, 255, 0.85)",
              backdropFilter: "blur(12px)",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
            },
          }}>
          <DialogTitle
            sx={{
              fontSize: "22px",
              fontWeight: "bold",
              textAlign: "center",
              marginBottom: 3,
              color: "#333",
            }}>
            Modificar Valores
          </DialogTitle>

          <DialogContent>
            {selectedRow && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                {/* === ENTREGAMOS === */}
                <DialogTitle
                  sx={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    textAlign: "center",
                    marginBottom: -5,
                    color: "#333",
                  }}>
                  Entregamos
                </DialogTitle>

                <Box
                  sx={{
                    position: "relative",
                    backgroundColor: BACKGROUND_COLORS.SECONDARY,
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "inset 0 0 5px rgba(0, 0, 0, 0.2)",
                    marginBottom: 2,
                  }}>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}>
                    {/* P. Lingote */}
                    <Box sx={{ textAlign: "center" }}>
                      <Box sx={{ fontWeight: "bold", fontSize: "14px" }}>
                        P. Lingote
                      </Box>
                      <Box sx={{ fontSize: "16px" }}>
                        {formatNumber(
                          parseFloat(selectedRow.peso_lingote) || 0
                        )}
                      </Box>
                      <Box
                        sx={{
                          color: "#888",
                          fontSize: "12px",
                          minHeight: "18px",
                        }}>
                        &nbsp;
                      </Box>
                    </Box>

                    {/* Au, Ag, Pt, Pd */}
                    {["Au", "Ag", "Pt", "Pd"].map((metal) => {
                      const peso =
                        parseFloat(
                          selectedRow[`Gramos_${metal.toLowerCase()}`]
                        ) || 0;
                      const pesoLingote =
                        parseFloat(selectedRow.peso_lingote) || 0;
                      const porcentaje =
                        pesoLingote > 0
                          ? ((peso / pesoLingote) * 100).toFixed(2)
                          : "0.00";

                      return (
                        <Box key={metal} sx={{ textAlign: "center" }}>
                          <Box sx={{ fontWeight: "bold", fontSize: "14px" }}>
                            {metal}
                          </Box>
                          <Box sx={{ fontSize: "16px" }}>
                            {formatNumber(peso)} g.
                          </Box>
                          <Box sx={{ color: "#888", fontSize: "14px" }}>
                            {porcentaje}%
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>

                {/* === RECIBIMOS === */}
                <DialogTitle
                  sx={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    textAlign: "center",
                    marginBottom: -5,
                    marginTop: -5,
                    color: "#333",
                  }}>
                  Recibimos
                </DialogTitle>

                <Box
                  sx={{
                    position: "relative",
                    backgroundColor: BACKGROUND_COLORS.SECONDARY,
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "inset 0 0 5px rgba(0, 0, 0, 0.2)",
                    marginBottom: 2,
                  }}>
                  {(() => {
                    const pLingoteRecibimos = ["Au", "Ag", "Pt", "Pd"].reduce(
                      (acc, metal) => {
                        const val = parseFloat(recibimosValues[metal]) || 0;
                        return acc + val;
                      },
                      0
                    );

                    return (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}>
                        {/* P. Lingote (ahora es la suma de los metales de "Recibimos") */}
                        <Box sx={{ textAlign: "center" }}>
                          <Box sx={{ fontWeight: "bold", fontSize: "14px" }}>
                            P. Lingote
                          </Box>
                          <Box sx={{ fontSize: "16px" }}>
                            {formatNumber(pLingoteRecibimos)}
                          </Box>
                          <Box
                            sx={{
                              color: "#888",
                              fontSize: "12px",
                              minHeight: "18px",
                            }}>
                            &nbsp;
                          </Box>
                        </Box>

                        {/* Au, Ag, Pt, Pd en base al pLingoteRecibimos */}
                        {["Au", "Ag", "Pt", "Pd"].map((metal) => {
                          const peso = parseFloat(recibimosValues[metal]) || 0;
                          const porcentaje =
                            pLingoteRecibimos > 0
                              ? ((peso / pLingoteRecibimos) * 100).toFixed(2)
                              : "0.00";

                          return (
                            <Box key={metal} sx={{ textAlign: "center" }}>
                              <Box
                                sx={{ fontWeight: "bold", fontSize: "14px" }}>
                                {metal}
                              </Box>
                              <Box sx={{ fontSize: "16px" }}>
                                {formatNumber(peso)} g.
                              </Box>
                              <Box sx={{ color: "#888", fontSize: "14px" }}>
                                {porcentaje}%
                              </Box>
                            </Box>
                          );
                        })}
                      </Box>
                    );
                  })()}
                </Box>

                {/* Inputs para modificar Au, Ag, Pt, Pd en "Recibimos" */}
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 3,
                  }}>
                  {["Au", "Ag", "Pt", "Pd"].map((metal) => (
                    <TextField
                      key={metal}
                      label={`${metal} g.`}
                      type='number'
                      value={recibimosValues[metal]}
                      onChange={(e) =>
                        setRecibimosValues({
                          ...recibimosValues,
                          [metal]: e.target.value,
                        })
                      }
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        backgroundColor: BACKGROUND_COLORS.SECONDARY,
                        borderRadius: "10px",
                        "& .MuiInputBase-input": {
                          padding: "12px",
                        },
                      }}
                    />
                  ))}
                </Box>

                {/* Checkbox Cuenta Metales */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginY: 2,
                  }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={cuentaMetales}
                        onChange={(e) => setCuentaMetales(e.target.checked)}
                        sx={{
                          color: MUI_COLORS.PRIMARY,
                          "&.Mui-checked": { color: MUI_COLORS.PRIMARY },
                        }}
                      />
                    }
                    label='Cuenta Metales'
                    sx={{ fontSize: "16px", color: "#333" }}
                  />
                </Box>

                {/* Botones */}
                <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
                  <Button
                    variant='outlined'
                    onClick={handleCloseDialogWithoutSaving}
                    sx={{
                      padding: "12px",
                      fontSize: "16px",
                      borderRadius: "8px",
                      textTransform: "none",
                    }}>
                    Cancelar
                  </Button>
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={handleCloseModifyDialog}
                    sx={{
                      backgroundColor: BRAND_COLORS.SECONDARY,
                      padding: "12px",
                      fontSize: "16px",
                      fontWeight: "bold",
                      borderRadius: "8px",
                      textTransform: "none",
                      "&:hover": { backgroundColor: BRAND_COLORS.PRIMARY_DARK },
                    }}>
                    Guardar
                  </Button>
                </Box>
              </Box>
            )}
          </DialogContent>
        </Dialog>
      </TableContainer>
    </Box>
  );
}
